import {getCypressToOrbitHooks, NamedIntervalType, isInsideAutomation} from '../../utils/automation-helpers';
import {TimeIntervalName} from './time-interval-names';
import {Check, TimeSpan} from '@sparkware/app-utils';

function convertToTimeSpan(interval: number | TimeSpan): TimeSpan {
    if(Check.isNumber(interval)) {
        return TimeSpan.fromMilliseconds(interval);
    } else {
        return interval;
    }
}

function namedTimer(name: TimeIntervalName | null | undefined,
                       handler: () => void,
                       interval: TimeSpan | number,
                       intervalType: NamedIntervalType,
                       javascriptFunction: (handler: () => void, timeout: number) => number): number {

    if(Check.isNullOrUndefined(handler)) {
        throw new Error('namedInterval: handler argument cannot be null or undefined');
    }

    if(Check.isNullOrUndefined(interval)) {
        throw new Error('namedInterval: interval argument cannot be null or undefined');
    }

    let timeSpan = convertToTimeSpan(interval);

    if(name && isInsideAutomation()) {
        const response = getCypressToOrbitHooks().onTimeIntervalCreation(name, handler, timeSpan, intervalType);
        if(response.ignoreJavaScriptImplementation) {
            // we are here because current running test decided to fake this timer
            return response.timerId;
        }
    }



    return javascriptFunction(handler, timeSpan.totalMilliseconds);
}



export function namedSetInterval(name: TimeIntervalName, handler: () => void, interval: TimeSpan | number): number {
    return namedTimer(name, handler, interval, NamedIntervalType.setInterval, setInterval);
}

export function namedSetTimeout(name: TimeIntervalName, handler: () => void, interval: TimeSpan | number): number {
    return namedTimer(name, handler, interval, NamedIntervalType.setTimeout, setTimeout);
}